module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-2.f50e1fb8.png";